·<template>
    <div class="mailing">
        <div v-if="closeShow">
            <p class="title">办理方式</p>
            <van-radio-group v-model="radio" @change="changeStyle">
                <van-cell-group>
                    <van-cell title="窗口办理" clickable @click="radio = '1'">
                        <van-radio slot="right-icon" name="1"/>
                    </van-cell>
                    <van-cell title="邮递服务" clickable @click="radio = '2'">
                        <van-radio slot="right-icon" name="2"/>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div>
        <!--确认的邮寄信息展示-->
        <div v-show="mailingShow">
            <div v-if="!addressShow">
                <p class="title">邮寄地址</p>
                <div class="address-info" @click="addAddress">
                    <div class="address-none">
                        <img src="~@public/img/matter/declare/addAddress.png">
                        <span>添加地址</span>
                    </div>
                    <van-icon class="mailing-icon" name="arrow"/>
                </div>
            </div>
            <div v-if="openShow">
                <div v-if="(matterInfo.emsConfig==='2' || matterInfo.emsConfig==='3') && addressShow">
                    <p class="title">取件地址</p>
                    <div>
                        <div>
                            <div class="button-info">
                                <van-checkbox v-model="pickUpChecked">上门取件<span class="tips">（邮递员上门收取申报人材料送至办理部门）</span>
                                </van-checkbox>
                            </div>
                            <div class="address-info" v-if="closeAddress" @click="changeAddress('take')">
                                <div class="mailing-info">
                                    <div class="name-phone-container">
                                        <span class="mail-name">寄件人：{{ takeInfo.addressee }}</span>
                                        <span class="mail-phone-number">{{ takeInfo.addresseeTel }}</span>
                                    </div>
                                    <p class="main-address">{{takeInfo.provinceName + takeInfo.cityName +
                                        takeInfo.areaName +
                                        takeInfo.adderss}}</p>
                                </div>
                                <van-icon class="mailing-icon" name="arrow"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="(matterInfo.emsConfig==='2' || matterInfo.emsConfig==='1') && addressShow ">
                    <p class="title">收件地址</p>
                    <div>
                        <div>
                            <div class="button-info">
                                <van-checkbox v-model="deliveryChecked">送件上门<span class="tips">（办理部门办结后邮递员将证书或材料送至申报人）</span>
                                </van-checkbox>
                            </div>
                            <div class="address-info" v-if="shouAddress" @click="changeAddress('receive')">
                                <div class="mailing-info">
                                    <div class="name-phone-container">
                                        <span class="mail-name">收件人：{{ receiveInfo.addressee }}</span>
                                        <span class="mail-phone-number">{{ receiveInfo.addresseeTel }}</span>
                                    </div>
                                    <p class="main-address">{{receiveInfo.provinceName + receiveInfo.cityName +
                                        receiveInfo.areaName +
                                        receiveInfo.adderss}}</p>
                                </div>
                                <van-icon class="mailing-icon" name="arrow"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="openShow">
                <p class="title">EMS邮寄资费说明</p>
                <div class="mail-price-detail">
                    <ul>
                        <li class="price-item">
                            <i>1</i>
                            <span>申请人自愿选择EMS快递服务并承担相应费用；</span>
                        </li>
                        <li class="price-item">
                            <i>2</i>
                            <span>邮寄费用：
                                <em v-if="matterInfo.emsConfig==='2' || matterInfo.emsConfig==='3'">上门取件费用{{takePrice}}元；</em>
                                <em v-if="matterInfo.emsConfig==='2' || matterInfo.emsConfig==='1'">送件上门费用{{receivePrice}}元；</em>
                            </span>
                        </li>
                        <li class="price-item">
                            <i>3</i>
                            <span>如邮件丢失、资料泄露、邮件逾期等情况处理详见EMS官网：www.11183.com.cn；</span>
                        </li>
                        <li class="price-item">
                            <i>4</i>
                            <span>详情咨询EMS客服电话11183；</span>
                        </li>
                    </ul>
                </div>
                <!--                <van-cell-group>-->
                <!--                    <van-cell title="取件费用" :value="`${takePrice}元`"-->
                <!--                              v-if="matterInfo.emsConfig==='2' || matterInfo.emsConfig==='3'"/>-->
                <!--                    <van-cell title="收件费用" :value="`${receivePrice}元`"-->
                <!--                              v-if="matterInfo.emsConfig==='2' || matterInfo.emsConfig==='1'"/>-->
                <!--                    <van-cell title="工本费" :value="`${totalCost}元`"/>-->
                <!--                </van-cell-group>-->
            </div>
        </div>
        <!--增加、编辑地址-->
        <div v-if="addAddressShow">
            <p class="title">添加地址</p>
            <van-cell-group>
                <van-field label="标题" v-model="title" clearable placeholder="请输入邮寄地址标题" clearable/>
                <van-field label="地区" v-model="areas" @focus="areaListShow = true" right-icon="arrow" readonly
                           placeholder="请选择地区"/>
                <van-field label="详细地址" type="textarea" rows="1" v-model="address" clearable autosize
                           placeholder="请输入详细地址" clearable/>
                <van-field label="邮政编码" v-model="postalCode" maxlength="6" clearable placeholder="请输入邮政编码" clearable/>
                <van-field label="收件人姓名" v-model="name" clearable placeholder="请输入收件人姓名" clearable/>
                <phone-input-number-keyboard @setPhone="getPhone" :passPhone="phone"></phone-input-number-keyboard>
                <van-cell title="设为默认地址">
                    <van-checkbox v-model="checkFlag" @change="setDefault"></van-checkbox>
                </van-cell>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button type="warning" class="btn-left" size="large" @click="goBack">返回</van-button>
                <van-button type="info" class="btn-right" size="large" @click="saveMailingAddress">保存</van-button>
            </div>
            <!--地址选项弹框-->
            <van-popup v-model="areaListShow" position="bottom">
                <van-area :area-list="areaList" :value="areaIndex" ref="areaSelcet" cancel-button-text="清除"
                          @confirm="areaSure"
                          @cancel="areaCancel"/>
            </van-popup>
        </div>
        <!--地址列表-->
        <div class="mailing-address-list" v-show="addressListShow">
            <p class="title">地址列表</p>
            <van-cell-group class="mailing-address-container" v-for="(item, index) in mailingAddressList" :key="index"
                            @click="selectAddress(index)">
                <van-cell :title="item.addressee" :value="item.addresseeTel"/>
                <div class="mailing-address-label">{{ item.provinceName + item.cityName + item.areaName + item.adderss
                    }}
                </div>
                <div class="operating">
                    <div class="mailing-address-radio-container defalut" v-if="item.defaultAddr === '1'">默认</div>
                    <div class="edit" @click.stop="edit(item, index)">
                        <img class="little_img" src="~@public/img/user/set-my-information/car_binding_edit.png"/>
                        <span class="operating-features">编辑</span>
                    </div>
                </div>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <div @click="goStyle">
                    <van-button type="warning" class="btn-left" size="large" @click="goBack">返回</van-button>
                </div>
                <van-button type="info" class="btn-right" size="large" @click="addMailingAddress">添加邮寄地址</van-button>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 申请人信息
     * Author: wangyan
     * Date: 2019-05-08
     * Time: 15:26
     */

    import {Icon, CellGroup, Cell, Field, Button, Toast, Popup, Area, Checkbox, RadioGroup, Radio} from 'vant'
    import AreaList from '@assets/js/api/AreaList'
    import PhoneInputNumberKeyboard from "@/components/phone-input-number-keyboard/PhoneInputNumberKeyboard"
    import {checkZipCode, checkPhoneNum} from '@assets/js/api/Regular'
    import {memberApi} from '@/api/member'
    import {mailApiMap} from '@/api/mail'
    import {matterApiMap} from '@/api/matter'

    export default {
        name: "Mailing",
        components: {
            PhoneInputNumberKeyboard,
            [Icon.name]: Icon,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [Popup.name]: Popup,
            [Area.name]: Area,
            [Checkbox.name]: Checkbox,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio
        },
        props: {
            matterInfo: {
                type: Object,
                default: () => ({})
            },
            declareInfo: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                radio: '1',
                pickUpChecked: true,
                deliveryChecked: true,
                takeInfo: {}, // 取件地址信息
                receiveInfo: {}, // 收件地址信息
                totalCost: 0, // 工本费
                takePrice: 0, // 收件费
                receivePrice: 0, // 寄件费
                addressShow: true, // 根据是否有邮寄地址显示与隐藏
                mailingShow: true, // 确认的邮寄信息展示的显示与隐藏
                addAddressShow: false, // 增加、编辑地址的显示与隐藏
                addressListShow: false, // 地址列表的显示与隐藏
                goBackStatus: '', // 返回按钮的状态值 'mailing'：返回确认的邮寄信息展示，'addressList'：返回地址列表
                editGuid: '', // 存放编辑地址时，此地址的guid
                editIndex: null, // 编辑的哪一个地址下标
                changeStatus: '', // 变更地址时存放收件或寄件的状态

                title: '', // 标题
                areas: '', // 存放拼接省市区县的信息
                provinceId: '', // 省级编号
                province: '', // 省名
                cityId: '', // 市级编号
                city: '', // 市名
                countyId: '', // 区县编号
                county: '', // 区县名
                areaListShow: false, // 地区三级联动的显示与隐藏
                areaList: AreaList, // 三级联动省市区县
                areaIndex: '', // 区域下标
                address: '', // 详细地址
                postalCode: '', // 邮编
                name: '', // 姓名
                receivePhone: '', // 手机号码
                isAddressDefault: 0, // 是否设为默认地址，'1'设置， '0'未设置
                checkFlag: false, // 复选框状态
                phone: '', // 传入手机号码自定义组件的号码
                mailingAddressList: [], // 邮寄地址列表
                openShow: false, //费用模块的显示与隐藏
                closeShow: true, //办理方式模块的显示与隐藏
                closeAddress: false,// 取件地址框的显示与隐藏
                buttonShow: true, //取件地址按钮显示与隐藏
                shouAddress: false, // 收件地址框的显示与隐藏
                butShow: true //收件地址按钮显示与隐藏
            }
        },
        watch: {
            pickUpChecked(val) {
                this.closeAddress = val ? true : false
            },
            deliveryChecked(val) {
                this.shouAddress = val ? true : false
            }
        },
        created() {
            this.getMailingAddress()
            this.changeStyle()
            this.count()

        },
        methods: {
            /**
             * 选择办理方式：1.窗口办理；2.邮寄服务
             */
            async changeStyle() {
                if (this.radio === '1') {
                    this.openShow = false
                    this.$emit('getStatus', false)
                } else {
                    // 选择邮寄时，再次判断是否可以邮寄
                    if (this.matterInfo.emsNeeded !== 'Y') {
                        Toast('该事项不支持EMS快递')
                        return;
                    }
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getDeptAddressById}/` + this.declareInfo.deptId)
                    if (res.data.succ == true) {
                        this.openShow = true
                        this.$emit('getStatus', true)
                    } else {
                        Toast('该申报单位不支持EMS快递')
                        return
                    }
                }
            },
            closeStyle() {
                this.closeShow = false
            },
            goStyle() {
                this.closeShow = true
            },

            /**
             * 获取邮寄信息
             */
            async getMailingAddress() {
                this.mailingAddressList = []
                try {
                    const res = await this.$httpUtils.getGatewayUtils(memberApi.memEMSAddr)
                    if (res.data.data.length > 0) { // 若没有维护地址，就显示"添加地址"入口
                        for (let index in res.data.data) {
                            this.mailingAddressList.push(res.data.data[index])
                        }
                        if (!this.changeStatus) { // 在选择地址状态下，进行的地址维护，重新对takeInfo、receiveInfo进行赋值
                            for (let index in this.mailingAddressList) {
                                if (this.mailingAddressList[index].defaultAddr === '1' && (this.matterInfo.emsConfig === '2' || this.matterInfo.emsConfig === '3')) { // 维护了地址且有默认地址
                                    this.takeInfo = this.mailingAddressList[index]
                                    this.buttonShow = false // 隐藏取件选择按钮
                                    this.closeAddress = true // 赋默认值时显示默认地址信息
                                }
                                if (this.mailingAddressList[index].defaultAddr === '1' && (this.matterInfo.emsConfig === '2' || this.matterInfo.emsConfig === '1')) { // 维护了地址且有默认地址
                                    this.receiveInfo = this.mailingAddressList[index]
                                    this.butShow = false // 隐藏送件选择按钮
                                    this.shouAddress = true // 赋默认值时显示默认地址信息
                                }
                            }
                            if (JSON.stringify(this.takeInfo) === '{}' && (this.matterInfo.emsConfig === '2' || this.matterInfo.emsConfig === '3')) { // 没有默认值，取地址列表第一个
                                this.takeInfo = this.mailingAddressList[0]
                                this.buttonShow = false
                                this.closeAddress = true
                            }
                            if (JSON.stringify(this.receiveInfo) === '{}' && (this.matterInfo.emsConfig === '2' || this.matterInfo.emsConfig === '1')) { // 没有默认值，取地址列表第一个
                                this.receiveInfo = this.mailingAddressList[0]
                                this.butShow = false
                                this.shouAddress = true
                            }
                        } else {
                            for (let index in this.mailingAddressList) {
                                if (this.mailingAddressList[index].guid === this.takeInfo.guid && (this.matterInfo.emsConfig === '2' || this.matterInfo.emsConfig === '3')) {
                                    this.takeInfo = this.mailingAddressList[index]
                                    this.buttonShow = false
                                    this.closeAddress = true
                                }
                                if (this.mailingAddressList[index].guid === this.receiveInfo.guid && (this.matterInfo.emsConfig === '2' || this.matterInfo.emsConfig === '1')) {
                                    this.receiveInfo = this.mailingAddressList[index]
                                    this.butShow = false
                                    this.shouAddress = true
                                }
                            }
                        }
                        this.getMailingCost(this.takeInfo).then(res => { // 初始化时获取取件费用
                            this.takePrice = res
                        })
                        this.getMailingCost(this.receiveInfo).then(res => { // 初始化时获取寄件费用
                            this.receivePrice = res
                        })
                        this.addressShow = true
                    } else {
                        this.addressShow = false
                    }

                } catch (error) {
                    console.log(error)
                }

            },

            /**
             * 计算工本费
             */
            count() {
                if (this.matterInfo.pays.length > 0) {
                    for (let index in this.matterInfo.pays) {
                        this.totalCost += Number(this.matterInfo.pays[index].value)
                    }
                }
            },

            /**
             * 新增地址
             */
            addAddress() {
                this.goBackStatus = 'mailing'
                this.addAddressShow = true
                this.mailingShow = false
                this.$emit('setNextUpShow', this.mailingShow) // 控制父组件'上一页'和'下一页'按钮的展示
            },

            /**
             * 地区三级联动选中，并赋值给areas展示在页面上
             * @param val 获得选中的地区的数组
             */
            areaSure(val) {
                this.provinceId = val[0].code
                this.province = val[0].name
                this.cityId = val[1].code
                this.city = val[1].name
                this.countyId = val[2].code
                this.county = val[2].name
                if (this.province === this.city) {
                    this.areas = `${this.province}/${this.county}`
                } else {
                    this.areas = `${this.province}/${this.city}/${this.county}`
                }
                this.areaListShow = false
            },

            /**
             * 关闭地区三级联动
             */
            areaCancel() {
                this.areaListShow = false
            },

            /**
             * 接收手机号码自定义键盘组件传来的phone值
             * @param value 验证码输入框phone值
             */
            getPhone(value) {
                this.receivePhone = value
            },

            /**
             * 根据返回值，改变是否默认地址的状态，'1'设置， '0'未设置
             * @param val 复选框布尔值
             */
            setDefault(val) {
                if (val) {
                    this.isAddressDefault = 1
                } else {
                    this.isAddressDefault = 0
                }
            },

            /**
             * 返回
             */
            goBack() {
                this.initializationAdress()
                if (this.goBackStatus === 'mailing') {
                    this.goBackStatus = ''
                    this.addAddressShow = false
                    this.addressListShow = false
                    this.mailingShow = true
                    this.$emit('setNextUpShow', this.mailingShow) // 控制父组件'上一页'和'下一页'按钮的展示
                } else if (this.goBackStatus === 'addressList') {
                    this.goBackStatus = 'mailing'
                    this.addAddressShow = false
                    this.addressListShow = true
                }
            },

            /**
             * 保存邮寄地址
             */
            async saveMailingAddress() {
                if (!this.title) {
                    Toast('请输入标题')
                } else if (!this.province && !this.county) {
                    Toast('请选择地区')
                } else if (!this.address) {
                    Toast('请输入详细地址')
                } else if (!this.postalCode) {
                    Toast('请输入邮编号码')
                } else if (!checkZipCode(this.postalCode)) {
                    Toast('请输入正确的邮编号码')
                } else if (!this.name) {
                    Toast('请输入收件人姓名')
                } else if (!this.receivePhone) {
                    Toast('请输入手机号码')
                } else if (!checkPhoneNum(this.receivePhone)) {
                    Toast('请输入正确的手机号码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '保存中...'
                    })
                    try {
                        const data = {
                            userGuid: this.$cookie.getUser().guid,
                            title: this.title,
                            province: this.provinceId,
                            provinceName: this.province,
                            city: '',
                            cityName: '',
                            area: this.countyId,
                            areaName: this.county,
                            adderss: this.address,
                            postCode: this.postalCode,
                            addressee: this.name,
                            addresseeTel: this.receivePhone,
                            street: '0',
                            streetName: '0',
                            defaultAddr: this.isAddressDefault
                        }
                        if(this.cityId==='429000'){
                            data.city=this.countyId
                            data.cityName=this.county
                        }else{
                            data.city=this.cityId
                            data.cityName=this.city
                        }
                        if (!this.editGuid) { // 判断是否是编辑地址还是新建地址
                            data.guid = ''
                        } else {
                            data.guid = this.editGuid
                        }
                        const res = await this.$httpUtils.postGatewayUtils(memberApi.memHbEMSAddr, data)
                        if (res.data.status === 212001) {
                            Toast.success('保存成功')
                            console.log(res.data)
                            await this.getMailingAddress()
                            this.initializationAdress()
                            this.editGuid = ''
                            this.goBackStatus = 'mailing'
                            // this.addressListShow = true
                            data.guid = res.data.msg
                            console.log('添加后的地址data:' )
                            console.log(data)
                            console.log(this.changeStatus)
                            if (this.changeStatus === 'take') {
                                this.closeAddress = true
                                this.buttonShow = false
                                this.takeInfo = data
                                this.takePrice = await this.getMailingCost(this.takeInfo)
                            } else if (this.changeStatus === 'receive') {
                                this.closeAddress = true
                                this.butShow = false
                                this.receiveInfo = data
                                this.receivePrice = await this.getMailingCost(this.receiveInfo)
                            }
                            this.changeStatus = ''
                            this.addAddressShow = false
                            this.goBack()
                            this.goStyle() // 显示办理方式单选按钮
                        } else {
                            Toast.fail('保存失败')
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },

            /**
             * 初始化新增地址页面
             */
            initializationAdress() {
                this.title = ''
                this.areas = ''
                this.provinceId = ''
                this.province = ''
                this.cityId = ''
                this.city = ''
                this.countyId = ''
                this.county = ''
                this.areaListShow = false
                this.areaList = AreaList
                this.areaIndex = ''
                this.address = ''
                this.postalCode = ''
                this.name = ''
                this.receivePhone = ''
                this.isAddressDefault = 0
                this.checkFlag = false
                this.phone = ''
            },

            /**
             * 编辑邮寄地址
             * @param item 返回点击当前的内容对象
             * @param index 返回点击当前的内容下标
             */
            edit(item, index) {
                this.editIndex = index
                let data = item
                // 判断传来的params对象是否有值
                if (Object.keys(data).length !== 0) {
                    this.editGuid = data.guid
                    this.title = data.title
                    this.provinceId = data.province
                    this.province = data.provinceName
                    this.cityId = data.city
                    this.city = data.cityName
                    this.countyId = data.area
                    this.county = data.areaName
                    // 初始化地区三级联动和显示地区
                    if (this.province && this.city && this.county) {
                        this.areaIndex = this.countyId
                        // 适配pc端的三级联动选择器，对'直辖市'进行判断却别展示信息。
                        if (this.city === '直辖市') {
                            this.areas = `${this.province}/${this.county}`
                        } else {
                            this.areas = `${this.province}/${this.city}/${this.county}`
                        }
                    } else if (this.province && this.city) {
                        this.areaIndex = this.cityId
                        // 适配pc端的三级联动选择器，对'直辖市'进行判断却别展示信息。
                        if (this.city === '直辖市') {
                            this.areas = `${this.province}`
                        } else {
                            this.areas = `${this.province}/${this.city}`
                        }
                    } else if (this.province) {
                        this.areaIndex = this.provinceId
                        this.areas = `${this.province}`
                    } else {
                        this.areas = ''
                    }
                    this.address = data.adderss
                    this.postalCode = data.postCode
                    this.name = data.addressee
                    this.phone = data.addresseeTel
                    this.receivePhone = data.addresseeTel
                    if (data.defaultAddr === '1') {
                        this.isAddressDefault = 1
                        this.checkFlag = true
                    } else {
                        this.isAddressDefault = 0
                        this.checkFlag = false
                    }
                    this.goBackStatus = 'addressList'
                    this.addAddressShow = true
                    this.addressListShow = false
                }
            },

            /**
             * 添加邮寄地址
             */
            addMailingAddress() {
                this.goBackStatus = 'addressList'
                this.addAddressShow = true
                this.addressListShow = false
                this.mailingShow = false
                this.$emit('setNextUpShow', this.mailingShow) // 控制父组件'上一页'和'下一页'按钮的展示
            },

            /**
             * 变更邮寄地址
             * @param status
             */
            changeAddress(status) {
                this.changeStatus = status
                this.goBackStatus = 'mailing'
                this.addressListShow = true
                this.mailingShow = false
                this.$emit('setNextUpShow', this.mailingShow) // 控制父组件'上一页'和'下一页'按钮的展示
                this.getMailingAddress()
            },

            /**
             * 选择邮寄地址
             * @param index 邮寄地址下标
             * @returns {Promise<void>} 邮寄收件、寄件费用
             */
            async selectAddress(index) {
                if (this.changeStatus === 'take') {
                    this.closeAddress = true
                    this.buttonShow = false
                    this.takeInfo = this.mailingAddressList[index]
                    this.takePrice = await this.getMailingCost(this.takeInfo)
                } else if (this.changeStatus === 'receive') {
                    this.shouAddress = true
                    this.butShow = false
                    this.receiveInfo = this.mailingAddressList[index]
                    this.receivePrice = await this.getMailingCost(this.receiveInfo)
                }
                console.log('选择邮寄地址')
                console.log(this.mailingAddressList[index])
                this.changeStatus = ''
                this.goBack()
                this.goStyle() // 显示办理方式单选按钮
            },

            /**
             * 得到邮件邮寄收件、寄件费用
             * @param addressInfo 选中的当前邮寄信息
             * @returns {Promise<any>} 返回邮寄收件、寄件费用
             */
            async getMailingCost(addressInfo) {
                return new Promise(async resolve => {
                    try {
                        const data = {
                            prov: addressInfo.provinceName,
                            city: addressInfo.cityName,
                            county: addressInfo.areaName
                        }
                        const res = await this.$httpUtils.postCommonUtils(mailApiMap.mailInfo, data)
                        if (res.data.succ) {
                            resolve(res.data.data.price)
                        }
                        resolve(0)
                    } catch (error) {
                        console.log(error)
                    }
                })
            },

            /**
             * 传值给父组件
             */
            passMailingValue() {
                let data = {
                    addressGuidQj: '', // 邮寄地址上门Guid
                    addressGuidSh: '', // 邮寄地址送件Guid
                    qjMoney: '', // 取件费用
                    shMoney: '', // 收件费用
                    gbMoney: '', // 工本费
                    takeData: {}, // 收件展示信息
                    receiveData: {} // 取件展示信息
                }

                if (this.radio === '2') {
                    if (this.takeInfo && this.pickUpChecked) {
                        data.addressGuidQj = this.takeInfo.guid
                        data.qjMoney = this.takePrice
                        data.takeData = this.takeInfo // 用作展示信息
                    }
                    if (this.receiveInfo && this.deliveryChecked) {
                        data.addressGuidSh = this.receiveInfo.guid
                        data.shMoney = this.receivePrice
                        data.receiveData = this.receiveInfo // 用作展示信息
                    }
                    data.gbMoney = this.totalCost
                }

                this.$emit('setMailingData', data)
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/user/set-my-information/mailing-address/MailingAddressList.less";

    .mailing {
        .title {
            padding: 0.3rem;
            color: #808080;
        }

        .mail-price-detail {
            background: #ffffff;
            padding: 0.3rem;
            display: flex;

            .price-item {
                border-bottom: 1px dashed #F3F3F3;
                line-height: 1rem;

                i {
                    width: .6rem;
                    height: .6rem;
                    display: inline-block;
                    background: #1989fa;
                    text-align: center;
                    line-height: .6rem;
                    border-radius: 50%;
                    color: #ffffff;
                    margin-right: .3rem;
                }

                em {
                    font-weight: normal;
                }
            }

            .price-item:last-child {
                border: none;
            }
        }

        .address-info {
            position: relative;
            width: 100%;
            background: white;
            overflow: hidden;
            .display-flex;
            .justify-content;

            &:before {
                content: '';
                left: 0;
                right: 0;
                bottom: 0;
                height: 4px;
                position: absolute;
                background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
                background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
                background-size: 80px;
            }
        }

        .mailing-info {
            float: left;
            width: calc(100% - 1rem);
            height: 100%;
            padding: 0.3rem 0 0.3rem 0.42rem;
        }

        .name-phone-container {
            display: flex;
            justify-content: space-between;
        }

        .mail-phone-number {
            margin-right: .5rem;
        }

        .main-address {
            margin: 10px 0;
        }

        .button-info {
            width: 100%;
            background: #fff;
            padding: .2rem 0 .2rem .4rem;

            .tips {
                font-size: .3rem;
                color: #b9976d;
            }
        }

        .mailing-icon {
            float: left;
            width: 1rem;
            .display-flex;
            .align-items;
            .justify-content;
        }

        .area {
            line-height: 0.45rem;
            color: #808080;
        }

        .address {
            padding: 0.2rem 0;
            font-size: 0.4rem;
            line-height: 0.55rem;
        }

        .myself {
            line-height: 0.45rem;
            color: #808080;
        }

        .my-name {
            margin-right: 0.2rem;
        }

        .address-none {
            float: left;
            width: calc(100% - 1rem);
            padding: 0.5rem 0 0.5rem 0.42rem;
            overflow: hidden;

            img {
                float: left;
                width: 0.9rem;
            }

            span {
                float: left;
                height: 100%;
                margin-left: 0.2rem;
                color: #808080;
                .display-flex;
                .align-items;
            }
        }

        .defalut {
            color: white;
            background: red;
            font-size: 0.3rem;
            padding: 0.025rem 0.15rem;
            border-radius: 0.1rem;
            margin-right: 0.15rem;
        }

        .button-info {
            width: 100%;
            background: #fff;
        }

        .primary {
            width: 2.4rem;
            height: 1rem;
            margin: 0.2rem 0 0.2rem 0.3rem;
        }

        .van-button__text {
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: .7rem;
        }
    }
</style>
